import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { Switch, Route, withRouter, Redirect } from 'react-router-dom';
import EvaluateAbilitiesPhysicalBasic from './EvaluateAbilitiesPhysicalBasic';
import EvaluateAbilitiesPhysicalIndepth from './EvaluateAbilitiesPhysicalIndepth';
import { SUBTABS, PHYSICAL_STEPS } from './ConstPaths';
//import { extractActivityButtons, extractLowTechActivities, areAllLowTech } from './ConstActivityBtns';

//Manage the wizard form for the Evaluate Abilities / Physical sub-tab
//Initialize the forms with props and manage those as local state.
//On Continue, update the global Session state with the local state from the forms. 
// Following pattern described in https://goshacmd.com/wizard-form-collect-info/

const propTypes = {
  firstName: PropTypes.string,
  pronouns: PropTypes.arrayOf(PropTypes.string),
  bodySites: PropTypes.arrayOf(PropTypes.string),
  bodySiteComments: PropTypes.string,
  updateSession: PropTypes.func.isRequired
};

const defaultProps = {
  firstName: 'the client',
  pronouns: ['they', 'them', 'their'],
  bodySites: [],
  bodySiteComments: ''
};

const BASE_URL = SUBTABS.PHYSICAL + "/";
//the steps of the wizard form:
const steps = PHYSICAL_STEPS;

const NEXT_SECTION = SUBTABS.VISUAL;

class EvaluateAbilitiesPhysical extends React.Component {
  constructor(props) {
    super(props);
    //manage the incoming values as local state
    this.state = {
      bodySites: this.props.bodySites ?? [],
      bodySiteComments: this.props.bodySiteComments
    };

    this.updateBodySiteRankings = this.updateBodySiteRankings.bind(this);

    this.saveBodySites = this.saveBodySites.bind(this);
    this.saveBodySiteComments = this.saveBodySiteComments.bind(this);
    this.saveBodySiteIndepth = this.saveBodySiteIndepth.bind(this);

    this.onContinue = this.onContinue.bind(this);
  }

  //Get the current step from the URL
  getCurrentStep(){
    //e.g. URL of '/gather-info/goals/intro' would have step of 'intro'
    const stepParam = this.props.match.params.step;
    if(stepParam){
      console.log("EvalAbilPhysical.getCurrentStep: got step from URL");
      return(stepParam);
    }
    else{
      console.log("EvalAbilPhysical.getCurrentStep: using default step");
      return(steps.INTRO);
    }
  }

  //On Continue for a given step:
  // figure out the next step and go to it
  // and if we're totally done with this section, submit the data.
  onContinue() {
    let history = this.props.history;
    let nextStep = '';
    let nextRoute = '';
    let goToNextSection = false;
    const curURL = new URL(window.location.href);

    switch(this.getCurrentStep()){
      case steps.BASIC:      
        nextStep = steps.INDEPTH;
        break;
      case steps.INDEPTH:
        nextStep = '';
        goToNextSection = true;
        break;
      default:
        console.log("   default next step");
        nextStep = steps.BASIC;
    }
    if (!goToNextSection) {
      nextRoute = BASE_URL + nextStep;
    } 
    else {
      // alert("Done with this section. Data saved are: " + JSON.stringify(this.state));
      nextRoute = NEXT_SECTION;
    }
    console.log("    pushing new route: " + nextRoute);
    history.push({
      pathname: nextRoute,
      search: curURL.search
    });
  }
  
  saveBodySites(){
    this.props.updateSession('bodySites', this.state.bodySites);
  }
  saveBodySiteComments(){
    this.props.updateSession('bodySiteComments', this.state.bodySiteComments);
  }
  saveBodySiteIndepth(){
    this.saveBodySites();
    this.saveBodySiteComments();
  }

  //called from the child form when the user changes anything
  updateLocalState(key) {
    return evt => {
      const target = evt.target; /* which input has been changed */
      let value = target.type === 'checkbox' ? target.checked: target.value;
      //handle 'bodySites' differently, since that holds an array rather than a single value
      if(key === 'bodySites'){
        const newItem=target.value;
        const newItemIndex = this.state.bodySites.indexOf(newItem);
        let bodySites = [...this.state.bodySites];
        //if an activity is checked: add it, if not already in list
        if((value===true) && (newItemIndex === -1)) {
          bodySites.push(newItem);
        }
        //activity unchecked: remove it, if already in the list
        else if ((value===false) && (newItemIndex !== -1)){
          bodySites.splice(newItemIndex, 1);
        }
        value = bodySites;
      }
      console.log("Updating EvaluateAbilitiesPhysical state with key: " + key + " value: " + value);
      this.setState({ [key]: value });
    }
  }

  updateBodySiteRankings(value){
    console.log("updateBodySiteRankings called with value: " + value);
    this.setState({ 'bodySites': value});
  }

  //If new props come in after rendering, update the views in this tab.
  //(This occurs when you refresh a view and it pulls data from the database.)
  componentDidUpdate(prevProps, prevState){
    //for values that are Arrays:
    if (_.isEqual(this.props.bodySites, prevProps.bodySites) === false){
      console.log("--incoming props: " + this.props.bodySites + " differ from prev props: " + prevProps.bodySites);
      this.setState({'bodySites': this.props.bodySites});
    };
    //for simple strings
    if (this.props.bodySiteComments !== prevProps.bodySiteComments){
        console.log("--incoming props: " + this.props.bodySiteComments + " differ from prev props: " + prevProps.bodySiteComments);
        this.setState({'bodySiteComments': this.props.bodySiteComments});
    }
  }

  render() {
    console.log("EvaluateAbilitiesPhysical.render()");
    const firstName = this.props.firstName;
    const pronouns = this.props.pronouns;
    const curURL = new URL(window.location.href);
    const searchQuery = curURL.search;

    return(
    <>
    <Switch>
      <Route path={BASE_URL + steps.BASIC}>
        <EvaluateAbilitiesPhysicalBasic
              key={steps.BASIC}
              firstName={firstName}
              pronouns={pronouns}
              bodySites={this.state.bodySites}
              onChangeBodySites={this.updateLocalState("bodySites")}
              saveFormData={this.saveBodySites}
              onContinue={this.onContinue}
            />
      </Route>
      <Route path={BASE_URL + steps.INDEPTH}>
        <EvaluateAbilitiesPhysicalIndepth
              key={steps.INDEPTH}
              firstName={firstName}
              pronouns={pronouns}
              bodySites={this.state.bodySites}
              bodySiteComments={this.state.bodySiteComments}
              onChangeBodySiteRankings={this.updateBodySiteRankings}
              onChangeBodySiteComments={this.updateLocalState("bodySiteComments")}
              saveFormData={this.saveBodySiteIndepth}
              onContinue={this.onContinue}
            />
      </Route>
      <Route path={BASE_URL}>
        <Redirect to={BASE_URL + steps.BASIC + searchQuery} />
      </Route>
    </Switch>
    </>
    );
  }
}

EvaluateAbilitiesPhysical.propTypes = propTypes;
EvaluateAbilitiesPhysical.defaultProps = defaultProps;

// withRouter wrapper provides access to the match, location, and history props
// "You can get access to the history object’s properties and the closest <Route>'s match 
// via the withRouter higher-order component. withRouter will pass updated 
// match, location, and history props to the wrapped component whenever it renders"
export default withRouter(EvaluateAbilitiesPhysical);
